import { createSlice, createAsyncThunk, createEntityAdapter } from "@reduxjs/toolkit";
import { sendToMeasurementsWithParams } from "@app/routes/vocabulary/api/index";
import { MEASUREMENT_TYPES } from "@amplio-common/measurements/constants";
import { sortByFieldAlphabetically } from "@amplio-common/funcs/commonFunctionalities";
import { setSpeechUUID } from "./studentSlice";
import { SLICE_NAMES } from "./sliceNames";

// Async actions
export const fetchSpeechUUID = createAsyncThunk(
  // "speech/fetchSpeechUUID",
  `${SLICE_NAMES?.SPEECH_SLICE}/fetchSpeechUUID`,
  async ({ gameUUID, studentId, treatmentId }, thunkAPI) => {
    const { response } = await sendToMeasurementsWithParams({
      measurements: [{ student_id: studentId, treatment_id: treatmentId }],
      uuid: gameUUID,
      measurement_type: MEASUREMENT_TYPES.SPEECH,
      instant_create: 1,
    });
    const speechUUID = response.measurements[0].uuid;
    thunkAPI.dispatch(setSpeechUUID(speechUUID));
    // eslint-disable-next-line no-use-before-define
    return response;
  },
);

//define root selector
const SPEECH_SLICE_STATE_ROOT_SELECTOR = state => state[SLICE_NAMES?.SPEECH_SLICE];
const sortFunc = sortByFieldAlphabetically("name");

export const speechStudentsAdapter = createEntityAdapter({
  sortComparer: sortFunc,
});

const initialState = {
  ...speechStudentsAdapter.getInitialState(),
};

export const speechMapTSToStudentStatus = (ts) => ({
  id: ts.student.id,
  name: ts.student.name,
  speechUUID: null,
  speechAnalysisResults: {},
  recordingsCount: 0,
  isRecording: false,
  isEnabledRecording: false,
  recordingStartTime: null,
  isSpeechLocked: false,
});

export const speechSlice = createSlice({
  name: SLICE_NAMES?.SPEECH_SLICE,
  initialState,
  reducers: {
    clearSpeech: () => ({ ...initialState }),
    speechUpdateStudentStatus: speechStudentsAdapter.updateOne,
    speechSetStudentsStatus: speechStudentsAdapter.setAll,
    speechUpdateAllStudents: speechStudentsAdapter.updateMany,
  },
});

const speechStudentsAdapterSelectors = speechStudentsAdapter.getSelectors(SPEECH_SLICE_STATE_ROOT_SELECTOR);
export default speechSlice.reducer;

//actions
export const { sendWordUUIDToStudent, sendWordToStudent, clearSpeech,
  speechUpdateAllStudents, speechSetStudentsStatus, speechUpdateStudentStatus } = speechSlice.actions;

//selectors
export const {
  selectAll: speechSelectAllStudentsStatus, selectIds: speechSelectStudentStatusIds, selectById: speechSelectStudentStatusById,
} = speechStudentsAdapterSelectors;
